/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
} = {
  dataStoreReference: {
    children: [],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'test',
    },
    type: 'DataStoreReference',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: '[\n    {\n        "someNumber": 0.8\n    }\n]',
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};

export const helpRenders: ComponentSample<'ProgressIndicator'>[] = [
  {
    title: 'Progress Indicator',
    description:
      'Trying changing the props and see how it renders in response to your changes.',
    page,
    exampleId: 'eg-01FYT41GHMFZ9XAH75PYS7FBGE',
    clearParentChildren: true,
    height: 280,
    visibleProps: ['type', 'size', 'thickness', 'linearWidth', 'color'],
    item: {
      parent: 'dataStoreReference',
      type: 'ProgressIndicator',
      props: {
        viewAttribute: 'someNumber',
        size: 80,
        linearWidth: 200,
        color: { type: 'text', value: 'success' },
        type: 'linear',
      },
      itemId: 'progressIndicator',
      children: [],
    },
  },
];
